export const APIKEY = '6nt5d1nJHkqbkphe';
export const CHATBOTID = '63906';
export const EXTERNALID = 'chirag1';


// WEBPACK FOOTER //
// ./src/shared/constant.js